var module = angular.module('octopusApp.certificates');

module.directive('certificateDetailsTable', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/certificates/details/certificate_details_table.html',
        scope: {
            certificate: '='
        },
        controller: function ($scope) {
            $scope.dateFormat = 'EEEE, MMMM d, yyyy HH:mm a Z';
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/details/certificate_details_table.js
// module id = 2883150362420307
// module chunks = 1